import React, { useState, useLayoutEffect, useContext, useRef } from "react";
import { Box } from "@material-ui/core";
import SideBar from "./../../components/SideBar";
import Header from "./../../components/header";
import BottonNavbar from "./../../components/BottomNavbar";
import Player from "../../components/Player";
import * as io from "socket.io-client";
import { SERVER_URL } from "./../../constants/api";
import "./index.scss";
import RouterOutlet from "./router-outlet";
import { getUserId, hasPremium, screenWidth } from "../../constants/function";
import { useSelector, useDispatch } from "react-redux";
import DirectChat from "../../components/DirectChat";
import { useEffect } from "react";
import NoInternet from "../../components/NoInternet";
import { SocketContext } from "./../../context/socket";
import cookieStorage from "../../services/cookie-storage";
// import Streaming from "../Streaming";
import Streaming from "../Streaming/Streaming";
import { useHistory } from "react-router-dom";
import { leaveStream } from "../../action/stream";
import { clearSong } from "../../action/songs";
import Advertisement from "../../components/Advertisement";
import { updatecount } from "../../action/adv";
function AppContainer(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    isStream,
    streamData,
    title,
    goal,
    isNew,
    goalDescription,
    shareUrl,
    music,
    obs,
  } = useSelector((state) => state.stream);
  const token = cookieStorage.getCookie("Authorization");
  const { Socket, setSocket } = useContext(SocketContext);
  const [isOnline, setIsOnline] = useState(true);
  const [openTip, setOpenTip] = React.useState(false);
  const [chatOpen, setChatOpen] = React.useState(false);
  const [openStream, setStream] = React.useState(false);
  const [userDetail, setUserDetail] = React.useState({
    userName: null,
    userId: null,
    timeStamp: null,
    playlistroomId: null,
  });

  const songs = useSelector((state) => state.songs);
  const currentSong = useRef(null);
  currentSong.current =
    songs["songs"].length > 0 ? songs["songs"][songs["index"]] : null;
  const currentSongs = useRef(0);
  currentSongs.current = songs["songs"].length;
  const { index } = useSelector((state) => state.songs);
  const { show } = useSelector((state) => state.chat);
  const { count } = useSelector((state) => state.adv);
  const [open, setOpen] = useState(true);
  const { track } = useSelector((state) => state.streamSong);
  const isPremium = hasPremium();
  const socket = useContext(SocketContext).Socket;
  const [showAdv, setShowAdv] = React.useState(false);

  useLayoutEffect(() => {
    function updateSize() {
      setOpen(screenWidth() > 576 ? true : false);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const handleChatOpen = (e) => {
    setUserDetail({ userName: e.userName, userId: e.userid });
    setChatOpen(true);
  };

  useEffect(() => {
    //console.log(
    //   "Initially " + (window.navigator.onLine ? "on" : "off") + "line"
    // );
    setIsOnline(window.navigator.onLine);

    window.addEventListener("online", () => {
      setIsOnline(true);
      if (isStream) window.location.reload();
    });
    window.addEventListener("offline", () => {
      if (isStream) {
        dispatch(leaveStream());
        history.push("/app/Home");
      }
      setIsOnline(false);
    });
  });
  useEffect(() => {
    if (!show) setChatOpen(false);
  }, [show]);

  useEffect(() => {
    if (isStream) {
      setChatOpen(false);
      if (songs["songs"].length > 0) {
        // close music player if song is playing and livestream starts
        songs["songs"][index].track.pause();
        dispatch(clearSong()); // clear song from state
      }
    }
  }, [isStream]);

  useEffect(() => {
    if (socket)
      socket.on("show-ad", (data) => {
        if (!isPremium) {
          const userId = getUserId();
          if (data.indexOf(userId) >= 0 && !count && !isStream) {
            if (!count && currentSong.current && currentSong.current.track) {
              currentSong.current.track.pause();
            }
            dispatch(updatecount(1));
          } else if (isStream && data.indexOf(userId) >= 0 && !count) {
            dispatch(updatecount(1));
          }
        }
      });
    // socket.on("show-ad-web", (data) => {
    //   if (!isPremium) {
    //     const userId = getUserId();
    //     if (data.indexOf(userId) >= 0 && !count && !isStream) {
    //       if (!count && currentSong.current && currentSong.current.track) {
    //         currentSong.current.track.pause();
    //       }
    //       dispatch(updatecount(1));
    //     } else if (isStream && data.indexOf(userId) >= 0 && !count) {
    //       dispatch(updatecount(1));
    //     }
    //   }
    // });
  }, [socket, songs]);
  useEffect(() => {
    setShowAdv(count ? true : false);
    if (
      !isStream &&
      !count &&
      currentSong.current &&
      currentSong.current.track &&
      currentSongs.current > 1
    ) {
      // currentSong.current.track.play();
    }
    // play livestream song after playing ad
    else if (isStream && track && !count) {
      track.resumeProcessAudioBuffer();
      track.setVolume(10);
    }
  }, [count]);
  useEffect(() => {
    // mute livestream song while playing ad
    if (isStream && track && count) {
      track.pauseProcessAudioBuffer();
      track.setVolume(0);
    }
  }, [track]);
  // useEffect(() => {
  //   if (localStorage.getItem("showAd") && !isPremium) {
  //     dispatch(updatecount(1));
  //   }
  // }, []);
  return (
    <>
      {isOnline ? (
        <Box sx={{ position: "relative", height: "100vh", overflow: "hidden" }}>
          {/* {props.location.pathname === "/app/Home" ||
      props.location.pathname === "/app/home" ||
      props.location.pathname === "/app" ? ( */}
          <Header
            toggleDrawer={() => setOpen(!open)}
            chatOpen={chatOpen}
            setChatOpen={(e) => {
              typeof e === "object" ? handleChatOpen(e) : setChatOpen(true);
            }}
          />
          {/* ) : null} */}
          <Box
            style={{
              width: "100%",
              display: "flex",
              height: "calc(100vh - 80px)",
            }}
          >
            <SideBar
              open={open}
              toggleDrawer={(e) =>
                screenWidth() < 575 ? setOpen(e) : setOpen(true)
              }
            />
            <Box
              style={{ width: "100%", position: "relative" }}
              id="__app_container"
              // className="__app_page"
              className={
                props.location.pathname === "/app/home" ||
                props.location.pathname === "/app"
                  ? "__app_ "
                  : props.location.pathname === "/app/Nft" ||
                    props.location.pathname === "/app/Nft/music" ||
                    props.location.pathname === "/app/Nft/studio" ||
                    props.location.pathname === "/app/Playlists"
                  ? "__app_nft_page"
                  : "__app_page "
              }
            >
              <RouterOutlet {...props} />
            </Box>
          </Box>
          {!isStream && songs && songs["songs"].length > 0 ? (
            <Player
              songIndex={songs["index"]}
              prevSongIndex={songs["prevIndex"]}
              songs={songs["songs"]}
              all={songs["all"]}
              showAdv={showAdv}
            />
          ) : null}
          {chatOpen ? (
            <DirectChat
              title={userDetail["userName"]}
              senderUserId={userDetail["userId"]}
              timeStamp={userDetail["timeStamp"]}
              playlistroomId={userDetail["playlistroomId"]}
              senndUserId={(userName, userId, timeStamp, playlistroomId) =>
                setUserDetail({
                  userName: userName,
                  userId: userId,
                  timeStamp: timeStamp,
                  playlistroomId: playlistroomId,
                })
              }
              onOutsideClick={() => {
                setUserDetail({ userName: null, userId: null });
                setChatOpen(false);
              }}
            />
          ) : null}
          {isStream ? (
            <Streaming
              streamData={streamData}
              title={title}
              goal={goal}
              isNew={isNew}
              goalDescription={goalDescription}
              shareUrl={shareUrl}
              music={music}
              obs={obs}
            />
          ) : null}
          {/* {(!isPremium && count % 3 === 0 && !isStream && count !== 0) ||
          (!isPremium && isStream && count === 0 && track) ||
          (!isPremium && isStream && count % 3 === 0 && track) ? (
            <Advertisement />
          ) : null} */}
          {showAdv && !isPremium ? <Advertisement /> : null}
        </Box>
      ) : (
        <NoInternet
          open={!isOnline}
          onRefresh={() => setIsOnline(window.navigator.onLine)}
        />
      )}
    </>
  );
}

export default AppContainer;
